import { useNavigate } from 'react-router-dom';
import { List, Avatar, Tag, Spin, Typography, Tabs } from 'antd';
import { SafetyOutlined, PhoneOutlined } from '@ant-design/icons';
import { useWisecureQuery } from '@wisecure/api-client/hooks';
import type { PendingValidationsResponse, PendingAgentItem } from '@wisecure/api-client';
import { queryKeys } from '@/api/query-keys';
import { PageHeader } from '@/components/PageHeader';
import { StatusBadge } from '@/components/base';
import { PhoneValidationList } from '@/components/PhoneValidationList';
import { neutral } from '@/theme';

const { Text } = Typography;

function AgentsValidationList() {
  const navigate = useNavigate();

  const { data, isLoading } = useWisecureQuery<PendingValidationsResponse>(
    queryKeys.dashboardPendingValidations,
    (client) => client.dashboard.dashboardControllerGetPendingValidations(),
  );

  const pendingAgents = data?.pendingAgents ?? [];

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: 80 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <List
      dataSource={pendingAgents}
      renderItem={(item: PendingAgentItem) => (
        <List.Item
          onClick={() => navigate(`/agents/${item.id}`)}
          style={{ cursor: 'pointer' }}
        >
          <List.Item.Meta
            avatar={<Avatar icon={<SafetyOutlined />} />}
            title={
              <span>
                {item.firstName} {item.lastName}
                <StatusBadge status={item.status} />
                <Tag
                  style={{
                    marginLeft: 8,
                    backgroundColor: `${neutral[300]}14`,
                    color: neutral[500],
                    borderColor: `${neutral[300]}40`,
                    borderRadius: 100,
                  }}
                >
                  {item.societyName}
                </Tag>
              </span>
            }
            description={
              <Text type="secondary">{item.email}</Text>
            }
          />
        </List.Item>
      )}
    />
  );
}

export function UsersValidationPage() {
  const { data } = useWisecureQuery<PendingValidationsResponse>(
    queryKeys.dashboardPendingValidations,
    (client) => client.dashboard.dashboardControllerGetPendingValidations(),
  );

  const pendingAgentsCount = data?.pendingAgents?.length ?? 0;

  const tabItems = [
    {
      key: 'agents',
      label: (
        <span>
          <SafetyOutlined />
          Agents ({pendingAgentsCount})
        </span>
      ),
      children: <AgentsValidationList />,
    },
    {
      key: 'phones',
      label: (
        <span>
          <PhoneOutlined />
          Téléphones
        </span>
      ),
      children: <PhoneValidationList />,
    },
  ];

  return (
    <div>
      <PageHeader title="Validations" subtitle="Gestion des validations en attente" />
      <Tabs defaultActiveKey="agents" items={tabItems} />
    </div>
  );
}
